import { render, staticRenderFns } from "./AllAddresses.vue?vue&type=template&id=3abf7ef7&"
import script from "./AllAddresses.vue?vue&type=script&lang=js&"
export * from "./AllAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports